import { render, staticRenderFns } from "./Games-Single.vue?vue&type=template&id=21280b7c&scoped=true"
import script from "./Games-Single.js?vue&type=script&lang=js&external"
export * from "./Games-Single.js?vue&type=script&lang=js&external"
import style0 from "./Games-Single.vue?vue&type=style&index=0&id=21280b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21280b7c",
  null
  
)

export default component.exports